<template>
  <a :href="this.notification.data.sport_event_url" class="notification-item-wrap notification-item-wrap_red_cup">
    <div class="event-name">
      <a :href="this.notification.data.sport_event_url">
        {{ I18n.t("sport_competitions.results_title") }}
      </a>
    </div>

    <div class="notification-item">
      <div class="notification-item-message">
        <span class="notification-item-img">
          <img :src="this.notification.data.profile_image" loading="lazy" v-if="!!this.notification.data.profile_image">
          <span v-else class="nickname">@{{ this.notification.data.profile_nickname }}</span>
        </span>
        <span class="notification-item-img-msg">
          {{
            I18n.t("sport_competitions.notifications.sport_competition_result_declined", { submitted_user_score: this.notification.data.submitted_user_score, confirmed_user_score: this.notification.data.confirmed_user_score }) }}
        </span>
      </div>
    </div>
  </a>
</template>

<script>
  export default {
    props: {
      notification: Object,
    },
    data() {
      return {
      }
    },
    methods: {
    }
  }
</script>

<style scoped>
</style>
